import React from 'react';
import './Policy.css';

const Policy = ({ navigateTo }) => {
    return (
        <div className="policy-container">
            <div className="policy-content">
                <h1>Privacy Policy</h1>
                
                <section>
                    <h2>Introduction</h2>
                    <p>
                        Welcome to Flappy Bird! This Privacy Policy explains how we collect, use, disclose, and 
                        safeguard your information when you play our game. Please read this Privacy Policy carefully.
                    </p>
                    <p>
                        We are committed to protecting your personal information and your right to privacy. If you have 
                        any questions about our privacy practices, please contact us using the details provided at the end 
                        of this policy.
                    </p>
                </section>
                
                <section>
                    <h2>Information We Collect</h2>
                    
                    <h3>Personal Information</h3>
                    <p>
                        When you use our game, we may collect certain personal information that can be used to identify you, such as:
                    </p>
                    <ul>
                        <li>Username or nickname (if you choose to save scores)</li>
                        <li>Device information and identifiers</li>
                        <li>Game play statistics and progress information</li>
                    </ul>
                    
                    <h3>Non-Personal Information</h3>
                    <p>
                        We may also collect non-personal information, such as:
                    </p>
                    <ul>
                        <li>Browser information</li>
                        <li>Cookies and usage data</li>
                        <li>Operating system information</li>
                    </ul>
                </section>
                
                <section>
                    <h2>How We Use Your Information</h2>
                    <p>
                        We may use the information we collect for various purposes, including:
                    </p>
                    <ul>
                        <li>To provide and maintain our game</li>
                        <li>To personalize your gaming experience</li>
                        <li>To improve our game and develop new features</li>
                        <li>To communicate with you about updates or changes</li>
                        <li>To detect, prevent, and address technical issues</li>
                    </ul>
                </section>
                
                <section>
                    <h2>Data Security</h2>
                    <p>
                        We have implemented appropriate technical and organizational security measures designed to 
                        protect the security of any personal information we process. However, please also remember 
                        that we cannot guarantee that the internet itself is 100% secure.
                    </p>
                </section>
                
                <section>
                    <h2>Children's Privacy</h2>
                    <p>
                        Our game is not intended for children under 13 years of age. We do not knowingly collect 
                        personal information from children under 13. If you are a parent or guardian and believe 
                        that your child has provided us with personal information, please contact us.
                    </p>
                </section>
                
                <section>
                    <h2>Changes to This Privacy Policy</h2>
                    <p>
                        We may update our Privacy Policy from time to time. We will notify you of any changes by 
                        posting the new Privacy Policy on this page and updating the "Last Updated" date.
                    </p>
                </section>
                
                <section>
                    <h2>Contact Us</h2>
                    <p>
                        If you have questions or concerns about this Privacy Policy, please contact us at:
                    </p>
                    <p>
                        Email: contact@flappybird.tv
                    </p>
                </section>
                
                <div className="policy-footer">
                    <p>Last Updated: June 1, 2023</p>
                    <button className="back-button" onClick={() => navigateTo('game')}>
                        Back to Game
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Policy; 